var TopBarView = require('./top-bar');

var ViewManager = Backbone.View.extend({
  template: 'layouts.main',

  initialize: function() {
    this.currentView = null;
    this.topBarView = new TopBarView();
  },

  events: {
    'click .fa-calendar': 'setFocusDate',
    'click .has-datepicker' : 'setFocusDate',
    'click .has-datepicker-birthdate' : 'setFocusBirthDate',
    'click .has-monthpicker-birthdate' : 'setFocusMonthBirthDate',
    'click .select-addon' : 'openSelect'
  },

  beforeRender: function() {
    if (this.currentView != null) {
      this.setView('.main-layout', this.currentView);
    }

    if (window.parent === window || !bookedby.staticData.storeGroupSettings.disableTopBarWhenIframe) {
      this.insertView('.top-bar', this.topBarView);
    }

    bookedby.app.loginForm && this.insertView('.modals-container', bookedby.app.loginForm);
    bookedby.app.reviewForm && this.insertView('.modals-container', bookedby.app.reviewForm);
    bookedby.app.signupForm && this.insertView('.modals-container', bookedby.app.signupForm);
    bookedby.app.changePasswordForm && this.insertView('.modals-container', bookedby.app.changePasswordForm);
    bookedby.app.passwordRecoveryForm && this.insertView('.modals-container', bookedby.app.passwordRecoveryForm);
    bookedby.app.checkInLaterModal && this.insertView('.modals-container', bookedby.app.checkInLaterModal);
    bookedby.app.employeeReviewsPopup && this.insertView('.modals-container', bookedby.app.employeeReviewsPopup);
    bookedby.app.storeReviewsPopup && this.insertView('.modals-container', bookedby.app.storeReviewsPopup);
    bookedby.app.confirmForm && this.insertView('.modals-container', bookedby.app.confirmForm);
    bookedby.app.signupPromptForm && this.insertView('.modals-container', bookedby.app.signupPromptForm);
  },

  addModalView: function(view) {
    this.insertView('.modals-container', view);
  },

  setCurrentPage: function(view) {
    this.currentView = view;
  },

  setFocusDate: function(e) {
    e.preventDefault();
    if ( $(e.target).parent().siblings('.has-datepicker-birthdate').length ) {
      $('.has-datepicker-birthdate').focus();
    } if ( $(e.target).parent().siblings('.has-monthpicker-birthdate').length ) {
      $('.has-monthpicker-birthdate').focus();
    } else {
      $('.has-datepicker').focus();
    }
  },

  setFocusBirthDate: function(e) {
    e.preventDefault();
    $('.has-datepicker-birthdate').focus();
  },

  setFocusMonthBirthDate: function(e) {
    e.preventDefault();
    $('.has-monthpicker-birthdate').focus();
  },

  openSelect: function (e) {
    e.preventDefault();
    // var parent = $(e.target.closest('.select-addon')).parent();
    var parent = $(e.target).closest('.select-addon').parent();
    var input = parent.find('input');
    if (input.length > 0) {
      console.log('focusing on input');
      input.focus();
      return;
    }

    var select = parent.find('select');
    if (select.length > 0) {
      select.simulate("mousedown");
    }
  }

});

module.exports = ViewManager;
